import React, { memo, CSSProperties } from 'react';
import { useTheme } from '../../styles';

export interface DotProps {
	className: string;
	vertical: boolean;
	active: boolean;
	point: number;
	range: number;
	min: number;
}

function Dot({ className, vertical, active, point, range, min }: DotProps) {
	const theme = useTheme();
	const offset = `${Math.abs(point - min) / range * 100}%`;
	let style: CSSProperties = vertical ? { bottom: offset } : { left: offset };
	style = active ? {
		...style,
		borderColor: theme.color.primary.hover,
	} : style;

	return (
		<span
			className={className}
			style={style}
		/>
	);
}

export default memo(Dot);
